import type { LocaleCode } from "../types/locale-code";

import { getLocaleMetadata } from "../registry/locale-registry";

function getClientNoticeOfPrivacyPracticesUrl(localeCode: LocaleCode): string {
  const metadata = getLocaleMetadata(localeCode);

  return `${metadata.canonicalOrigin}${metadata.country.clientNoticeOfPrivacyPracticesPath}`;
}

export { getClientNoticeOfPrivacyPracticesUrl };
